import { ContractName } from '@/constants/contract-addresses'
import useReadContract from './useReadContract'
import { blockpotTokenAbi } from '@/abi/blockPotTokenAbi'

export default function useBlockPotTokenRead() {
    return useReadContract(ContractName.BLOCK_POT_TOKEN, blockpotTokenAbi).read
}